
class CartOptions extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', async (e) => {
      const box = e.target.closest('[data-cart-attribute]');
      if (!box) return;

      box.disabled = true;
      try {
        await window.CartAPI.update(
          { attributes: { [box.dataset.cartAttribute]: box.checked ? 'yes' : '' } },
          { source: 'cart-options' },
        );
      } catch (err) {
        box.checked = !box.checked;   
      } finally {
        box.disabled = false;
      }
    });
  }
}

customElements.define('cart-options', CartOptions);
